import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a77706c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "inicio",
  class: "main-hero fundo-grade"
}
const _hoisted_2 = { class: "container-site conteudo-hero" }
const _hoisted_3 = { class: "coluna-texto" }
const _hoisted_4 = { class: "selo-local" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ponto-amarelo" }, null, -1))
const _hoisted_6 = { class: "titulo-hero" }
const _hoisted_7 = { class: "marcacao" }
const _hoisted_8 = { class: "subtitulo-hero" }
const _hoisted_9 = { class: "botoes-hero" }
const _hoisted_10 = ["title"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "20",
  height: "20",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 12h14M13 6l6 6-6 6" })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "moldura-amarela" }, null, -1))
const _hoisted_13 = { class: "carrossel" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icone-cartao" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    width: "22",
    height: "22",
    fill: "none",
    stroke: "#141213",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M13 2L4.5 13h5L10 22l8.5-11h-5z" })
  ])
], -1))
const _hoisted_16 = { class: "texto-cartao" }
const _hoisted_17 = { class: "titulo-cartao" }
const _hoisted_18 = { class: "subtitulo-cartao" }
const _hoisted_19 = { class: "pontos-carrossel" }
const _hoisted_20 = ["onClick", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.conteudo.hero.selo), 1)
        ]),
        _createElementVNode("h1", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.conteudo.hero.titulo) + " ", 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.conteudo.hero.tituloDestaque), 1)
        ]),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.conteudo.hero.subtitulo), 1),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "botao-pilula",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.abrirWhatsApp())),
            title: _ctx.TextoWhatsApp
          }, [
            _createTextVNode(" Fazer um orçamento "),
            _hoisted_11
          ], 8, _hoisted_10),
          _createElementVNode("a", {
            class: "botao-contorno",
            href: "#servicos",
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.rolarPara('servicos')), ["prevent"]))
          }, " Ver serviços ")
        ])
      ]),
      _createElementVNode("div", {
        class: "coluna-imagem",
        onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pausar())),
        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.retomar()))
      }, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, i) => {
            return (_openBlock(), _createElementBlock("img", {
              key: `${i}-${slide.imagem}`,
              src: _ctx.urlDaImagem(slide.imagem),
              alt: slide.titulo,
              class: _normalizeClass(["imagem-hero", { 'slide-ativo': i === _ctx.indice }])
            }, null, 10, _hoisted_14))
          }), 128))
        ]),
        _createVNode(_Transition, {
          name: "troca",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", {
              class: "cartao-flutuante",
              key: _ctx.indice
            }, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.slideAtual.titulo), 1),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.slideAtual.subtitulo), 1)
              ])
            ]))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, i) => {
            return (_openBlock(), _createElementBlock("button", {
              key: `ponto-${slide.imagem}`,
              class: _normalizeClass(["ponto", { 'ponto-ativo': i === _ctx.indice }]),
              onClick: ($event: any) => (_ctx.irParaSlide(i)),
              "aria-label": `Ver foto ${i + 1}: ${slide.titulo}`
            }, null, 10, _hoisted_20))
          }), 128))
        ])
      ], 32)
    ])
  ]))
}